import { RegisterPage } from './register.component';
import { connect } from 'react-redux';
import { userRegister, userGoogleRegister } from './../../api/user/userAction';

const mapDispatchToProps = {
    userRegister,
    userGoogleRegister
};

const mapStateToProps = state => ({
    isLoading: state.userPage.isLoading,
    isLoggedIn: state.userPage.isLoggedIn
});
export const RegisterContainer = connect(mapStateToProps, mapDispatchToProps)(RegisterPage);